export default __webpack_public_path__ + "static/media/dropSubmittedSuccess@3x.98f2f0cb.png";